import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { EditIcon } from "../../../ui/icons/edit"
import { TrashIcon } from "../../../ui/icons/trash"
import { formatterDate, normativa, optionsFormatter } from "../../../utils"
import { GetByIdAnagraphic, resetGetByIdStatus } from "../boxAnagrafica/slice"
import { GetAllPersonalManagement, resetGetAllPersonalManagementResourcesStatus } from "../slice"
import { TrainingDTO } from "./dataService/dto"
import { addPMResource, GetAllTraining, resetGetAllTrainingsStatus, resetPMResources, resetTrainingDeleteStatus, setTrainingIdToUpdate, setTrainings, setUpdateTrainingActivity, setUpdateTrainingAttendanceRegister, setUpdateTrainingCredits, setUpdateTrainingEndingDate, setUpdateTrainingExternalTeacher, setUpdateTrainingExternalTeacherFunction, setUpdateTrainingHeadquarter, setUpdateTrainingInternalTeacher, setUpdateTrainingInternalTeacherFunction, setUpdateTrainingOtherData, setUpdateTrainingParticipants, setUpdateTrainingStartingDate, setUpdateTrainingTopicsCovered, setUpdateTrainingWebinar, TrainingDelete } from "./slice"

export function BoxFormazione() {
    const dispatch = useAppDispatch()
    const trainingState = useAppSelector(state => state.PMTraining)
    const PMState = useAppSelector(state => state.personalManagement)
    const anagraficaState = useAppSelector(state => state.PMAnagrafica)
    const navigate = useNavigate()

    useEffect(() => {
        dispatch(resetPMResources())
        dispatch(GetAllPersonalManagement(PMState.filters))
        dispatch(GetAllTraining(trainingState.getAllTrainingFilters))
    }, [])

    useEffect(() => {
        if (trainingState.getAllTrainingsStatus === 'successfully' &&
            trainingState.getAllTrainingsResponse !== undefined
        ) {
            dispatch(resetGetAllTrainingsStatus())
            dispatch(setTrainings(trainingState.getAllTrainingsResponse.data))
        }
    }, [trainingState.getAllTrainingsStatus])

    useEffect(() => {
        if (PMState.getAllPersonalManagementResourcesStatus === 'successfully' &&
            PMState.getAllPersonalManagementResourcesResponse !== undefined
        ) {
            dispatch(resetGetAllPersonalManagementResourcesStatus())
            const data = PMState.getAllPersonalManagementResourcesResponse.data
            for (let i = 0; i < data.length; i++) {
                dispatch(GetByIdAnagraphic(String(data[i].anagraphicId)))
            }
        }
    }, [PMState.getAllPersonalManagementResourcesStatus])

    useEffect(() => {
        if (anagraficaState.GetByIdAnagraphicStatus === 'successfully' &&
            anagraficaState.getByIdAnagraphicRequest !== undefined
        ) {
            dispatch(resetGetByIdStatus('idle'))
            const data = anagraficaState.getByIdAnagraphicRequest
            dispatch(addPMResource({ value: data.personalManagementId, label: `${data.name} ${data.surname}` }))
        }
    }, [anagraficaState.GetByIdAnagraphicStatus])

    useEffect(() => {
        if (trainingState.trainingDeleteStatus === 'successfully') {
            dispatch(resetTrainingDeleteStatus())
            dispatch(GetAllTraining(trainingState.getAllTrainingFilters))
        }
    }, [trainingState.trainingDeleteStatus])

    const handleNorms = (subs: string[]) => {
        if (!subs || subs.length === 0)
            return '';
        return subs.slice(0, -1)
            .map(s => `${optionsFormatter(s, normativa)} - `)
            + optionsFormatter(subs[subs.length - 1], normativa)!
    }

    const handleOnEdit = (t: TrainingDTO) => {
        dispatch(setTrainingIdToUpdate(t.id))
        dispatch(setUpdateTrainingStartingDate(t.starting))
        dispatch(setUpdateTrainingEndingDate(t.ending))
        dispatch(setUpdateTrainingCredits(t.credits))
        dispatch(setUpdateTrainingWebinar(t.webinar))
        dispatch(setUpdateTrainingHeadquarter(t.sede))
        dispatch(setUpdateTrainingInternalTeacher(t.internalTeacher))
        dispatch(setUpdateTrainingInternalTeacherFunction(t.internalTeacherFunction))
        dispatch(setUpdateTrainingExternalTeacher(t.externalTeacher))
        dispatch(setUpdateTrainingExternalTeacherFunction(t.externalTeacherFunction))
        dispatch(setUpdateTrainingParticipants(t.participantsIds))
        dispatch(setUpdateTrainingAttendanceRegister(t.attendanceRegister))
        dispatch(setUpdateTrainingTopicsCovered(t.topicsCovered))
        dispatch(setUpdateTrainingOtherData(t.otherData))
        dispatch(setUpdateTrainingActivity(t.trainingActivities))
        navigate('/editFormazione')
    }

    return (
        <div className="w-full overflow-x-auto rounded-xl border border-neutral-200 shadow-sm">
            <table id="customers-table" className="w-full border-collapse text-sm">
                <thead>
                    <tr className="bg-brandPrimary-600 text-white uppercase text-xs tracking-wide h-[52px]">
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tl-xl">Dal/Al</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Crediti</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Tipo di formazione</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Normativa</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Argomenti trattati</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Registro presenze - CDX RPA</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Altri dati</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Elenco partecipanti</th>
                        <th className="px-3 py-3 text-center font-semibold whitespace-nowrap rounded-tr-xl w-[80px]"></th>
                    </tr>
                </thead>
                <tbody>
                    {trainingState.trainings.length === 0 ? (
                        <tr>
                            <td colSpan={9} className="px-3 py-3 text-center text-neutral-500 bg-white">
                                Nessuna formazione trovata
                            </td>
                        </tr>
                    ) : (
                        trainingState.trainings.map((t, index) =>
                            <tr
                                className={`text-left border-b border-neutral-200 transition-colors duration-150 hover:bg-brandPrimary-50 ${index % 2 === 0 ? 'bg-white' : 'bg-neutral-50'}`}
                                key={t.id}
                            >
                                <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                    <div>{formatterDate(t.starting)}</div>
                                    <div>{formatterDate(t.ending)}</div>
                                </td>
                                <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{t.credits}</td>
                                <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{t.webinar ? 'Webinar' : 'In Presenza'}</td>
                                <td className="px-3 py-2 text-neutral-700">
                                    <ul className="list-disc pl-4">
                                        {t.trainingActivities.map((activity, activityIndex) => (
                                            <li key={`${t.id}-norm-${activityIndex}`}>{handleNorms(activity.norms || [])}</li>
                                        ))}
                                    </ul>
                                </td>
                                <td className="px-3 py-2 text-neutral-700">{t.topicsCovered}</td>
                                <td className="px-3 py-2 text-neutral-700">{t.attendanceRegisterInfo || '-'}</td>
                                <td className="px-3 py-2 text-neutral-700">{t.otherData || '-'}</td>
                                <td className="px-3 py-2 text-neutral-700">{t.participants.join(' - ')}</td>
                                <td className="px-3 py-2">
                                    <div className="flex gap-2 justify-center">
                                        <button
                                            className="cursor-pointer"
                                            onClick={() => {
                                                handleOnEdit(t)
                                            }}
                                        >
                                            <EditIcon color={"Orange"} size={18} />
                                        </button>
                                        <button className="cursor-pointer" onClick={() => { dispatch(TrainingDelete(t.id!)) }}>
                                            <TrashIcon color={"red"} size={18} />
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        )
                    )}
                </tbody>
            </table>
        </div>
    )
}